export default "__VITE_ASSET__CjFfbLGo__"